import apiRequest from "./apiRequest";

const emailApi = {
  /* =========================     EMAIL TEMPLATES  ========================= */

  async createTemplate(data, token) {
    return apiRequest("/api/email/templates", "POST", token, data);
  },

  async getAllTemplates(token) {
    return apiRequest("/api/email/templates", "GET", token);
  },

  async getTemplateById(templateId, token) {
    return apiRequest(`/api/email/templates/${templateId}`, "GET", token);
  },

  async updateTemplate(templateId, data, token) {
    return apiRequest(`/api/email/templates/${templateId}`, "PUT", token, data);
  },

  async deleteTemplate(templateId, token) {
    return apiRequest(`/api/email/templates/${templateId}`, "DELETE", token);
  },

  async toggleTemplate(templateId, token) {
    return apiRequest(`/api/email/templates/${templateId}/toggle`, "PATCH", token);
  },

  async getTemplatesByType(emailType, token) {
    return apiRequest(`/api/email/templates/type/${emailType}`, "GET", token);
  },

  async getTemplateByName(templateName, token) {
    return apiRequest(`/api/email/templates/name/${templateName}`, "GET", token);
  },

  async getActiveTemplates(token) {
    return apiRequest("/api/email/templates/active", "GET", token);
  },

  /* =========================     SEND / PREVIEW EMAIL  ========================= */

  async sendEmail(to, subject, body, token) {
    return apiRequest(
      `/api/email/send?to=${to}&subject=${subject}&body=${body}`,
      "POST",
      token
    );
  },

  async previewEmail(data, token) {
    return apiRequest("/api/email/preview", "POST", token, data);
  },

  async previewTestEmail(data, token) {
    return apiRequest("/api/email/preview/test", "POST", token, data);
  },

  /* =========================     EMAIL SCHEDULE  ========================= */

  async createSchedule(data, token) {
    return apiRequest("/api/email/schedules", "POST", token, data);
  },

  async getAllSchedules(token) {
    return apiRequest("/api/email/schedules", "GET", token);
  },

  async getScheduleById(scheduleId, token) {
    return apiRequest(`/api/email/schedules/${scheduleId}`, "GET", token);
  },

  async deleteSchedule(scheduleId, token) {
    return apiRequest(`/api/email/schedules/${scheduleId}`, "DELETE", token);
  },

  async toggleSchedule(scheduleId, token) {
    return apiRequest(`/api/email/schedules/${scheduleId}/toggle`, "PATCH", token);
  },

  async getSchedulesByAccount(accountId, token) {
    return apiRequest(`/api/email/schedules/account/${accountId}`, "GET", token);
  },

  async getEnabledSchedulesByAccount(accountId, token) {
    return apiRequest(
      `/api/email/schedules/account/${accountId}/enabled`,
      "GET",
      token
    );
  },

  /* =========================     BULK ACTIONS  ========================= */

  async bulkEnable(templateIds, token) {
    return apiRequest("/api/email/bulk/enable", "POST", token, templateIds);
  },

  async bulkDelete(templateIds, token) {
    return apiRequest("/api/email/bulk/delete", "POST", token, templateIds);
  },

  async bulkConfigure(data, token) {
    return apiRequest("/api/email/bulk/configure", "POST", token, data);
  },

  /* =========================     EMAIL HISTORY  ========================= */

  async getHistoryByStatus(status, token) {
    return apiRequest(`/api/email/history/status/${status}`, "GET", token);
  },

  async getHistoryByAccount(accountId, token) {
    return apiRequest(`/api/email/history/account/${accountId}`, "GET", token);
  },

  async getHistoryByAccountAndStatus(accountId, status, token) {
    return apiRequest(
      `/api/email/history/account/${accountId}/status/${status}`,
      "GET",
      token
    );
  },

  /* =========================     ANALYTICS   ========================= */

  async getEmailAnalytics(token) {
    return apiRequest("/api/email/analytics", "GET", token);
  },
};

export default emailApi;